import { render, staticRenderFns } from "./lcsjStatCard.vue?vue&type=template&id=53dd22f7&scoped=true"
import script from "./lcsjStatCard.vue?vue&type=script&lang=js"
export * from "./lcsjStatCard.vue?vue&type=script&lang=js"
import style0 from "./lcsjStatCard.vue?vue&type=style&index=0&id=53dd22f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd22f7",
  null
  
)

export default component.exports